var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
        _vm.controlClass,
        { 'c-disclosure-triangle--expanded' : _vm.value },
        {'is-enabled' : _vm.enabled }
    ],on:{"click":_vm.handleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }